import React from 'react';
import { Layer } from 'react-konva';
import { LayerType } from '../../../types';
import { useMapCanvas } from '../contexts/MapCanvasContext';

export interface MapCanvasViewLayersProps {
  showOutside?: boolean;
  getShapes: (type: LayerType) => React.ReactNode;
}

export const MapCanvasViewLayers: React.FC<MapCanvasViewLayersProps> = ({
  showOutside = true,
  getShapes
}) => {
  const { editingZoneWidth, editingZoneHeight } = useMapCanvas();

  return (
    <>
      <Layer>
        {getShapes('floor')}
        {getShapes('background')}
      </Layer>
      <Layer
        clipFunc={
          !showOutside
            ? (ctx) => {
                ctx.beginPath();
                ctx.rect(0, 0, editingZoneWidth, editingZoneHeight);
                ctx.closePath();
              }
            : undefined
        }
      >
        {getShapes('shapes')}
        {getShapes('spots')}
      </Layer>
    </>
  );
};
